import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { storeInLocalStorage } from "../../Utils/LocalStorage";
import { AuthContext } from "../../context/AuthContext";
import toast from "react-hot-toast";

const GoogleAuthCallback = () => {
  const {setIsAuthenticated,setIsLoading} = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    const handleGoogleCallback = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const token = queryParams.get("access_token"); // Assuming token is passed in query params
      const userId = queryParams.get("USERID");
      const email = queryParams.get("email");

      if (token && userId) {
        // Save token to localStorage or context
        storeInLocalStorage({
          access_token:token,
          user_id:userId,
          email:email
        })
        setIsAuthenticated(true);
        // Navigate to home or dashboard
        navigate("/");
      } else {
        // Handle error or failed login
        navigate("/login");
        toast.error("failed to login with google");
      }
    };

    handleGoogleCallback();
    setIsLoading(false);
  }, [navigate]);

  return <div className="h-screen">Processing Google Login...</div>;
};

export default GoogleAuthCallback;
